module.exports = __webpack_public_path__ + "static/1.Disclosure of Risks of Margin Trading-956b80f4110e58aeecafcdaa23e4fae6.pdf";